const card = {
    boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
    border: '2px solid #EEE',
    borderRadius: '8px',
    padding: {
        desktop: '40px',
        mobile: '24px',
    },
    width: '100%',
};
export default { card };
